import { DEST } from "@/constants/testIds";

// One slot in the editorial magazine layout.
function GalleryTile({ src, alt, slug, idx, className }) {
  return (
    <div
      data-testid={DEST.galleryImage(slug, idx)}
      className={`img-zoom overflow-hidden bg-ivory-alt ${className}`}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full h-full object-cover"
      />
    </div>
  );
}

// Layout slots (Tailwind classes). Heights are mathematically aligned so the
// two main rows are perfectly even.
const SLOTS = [
  "col-span-12 md:col-span-8 aspect-[16/10]", // 0 — wide left
  "col-span-12 md:col-span-4 aspect-[4/5]",   // 1 — tall right
  "col-span-12 md:col-span-4 aspect-[4/5]",   // 2 — tall left
  "col-span-12 md:col-span-8 aspect-[16/10]", // 3 — wide right
  "col-span-12 aspect-[21/8]",                // 4 — optional panoramic finale
];

export default function DestinationGallery({ d }) {
  if (!d.gallery || d.gallery.length < 4) return null;

  return (
    <div className="mt-24">
      <div className="eyebrow mb-8">Through the Lens</div>
      <div className="grid grid-cols-12 gap-3 md:gap-5">
        {d.gallery.slice(0, 5).map((src, i) => (
          <GalleryTile
            key={src}
            src={src}
            alt={`${d.name} — ${i + 1}`}
            slug={d.slug}
            idx={i}
            className={SLOTS[i]}
          />
        ))}
      </div>
    </div>
  );
}
